import './App.css';
import './custom.scss';
import React, { useState, useEffect } from 'react';
import HSM, { StateBox } from './HSM.tsx';
import type { StateBoxProps } from '.HSM.tsx';
import BCNav from './BCNav';
import { HSMRenderer } from './HSMRenderer.tsx';
import cloneDeep from 'lodash/cloneDeep';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HSMRendererProps, RENDERER_MODE } from './HSMRenderer.tsx';
import AccountWorkflows from './AcountWorkflows.tsx';
import EditableHSMRenderer from './EditableHSMRenderer.tsx';
import { EditableHSMRendererProps } from './EditableHSMRenderer.tsx';
import ViewOnlyHSMRenderer from './ViewOnlyHSMRenderer.tsx';
import ADLs from './ADLs.tsx';
import Avatars from './Avatars.tsx';
import NavigationBar from './NavBar.tsx';
import Homepage from './Homepage.tsx';

let numStatesMade = 0;

function nextUID(): number {
  const uid = numStatesMade;
  numStatesMade++;
  return uid;
}

function setStartingId(id: number) {
  numStatesMade = id;
}

export type UserContext = {
  id: number;
  avatarID: string;
  googleKey: string;
  name: string;
  occupation: string;
};

function App(testUser: UserContext) {
  const [cursor, setCursor] = useState('auto');
  const [activityProps, setActivityProps] = useState({});
  const [crumbIds, setCrumbIds] = useState([]);

  // configures new statebox props with the supplied initializer props. this function ensures
  // that all stateboxes it returns have a unique ID. the ID in the initializer props, if present,
  // will be ignored.
  function configureStateBox(props: StateBoxProps) {
    let stateBoxProps = { ...props, id: nextUID() };
    return stateBoxProps;
  }

  // let testUserContext : UserContext = {
  //   id: 1,
  //   avatarID: '61ff3d6ef7e387abdedc64e3',
  //   googleKey: 'hey',
  //   name: 'Ahmed Moustafa',
  //   occupation: 'Roboticist',
  // }

  let rendererProps: EditableHSMRendererProps = {
    userContext: testUser,
    nextUID: nextUID,
    setStartingId: setStartingId,
    setCursor: setCursor,
  };

  // TODO do we still need clonedeep ? prolly not
  let deep = cloneDeep({ ...activityProps });

  return (
    <div className='App' style={{ cursor }}>
      <Routes>
        <Route path='/' element={<Homepage />} />
        <Route
          path='/edit/:id'
          element={<EditableHSMRenderer {...rendererProps} />}
        />
        <Route
          path='/view/:id'
          element={<ViewOnlyHSMRenderer {...rendererProps} />}
        />
        <Route path='/adls/:avatar' element={<ADLs userContext={testUser} />} />
        <Route path='/avatars' element={<Avatars />} />
      </Routes>
      {/* <HSMRenderer newState={configureStateBox} activityProps={deep} setActivityProps={setActivityProps} crumbIds={crumbIds} setCrumbIds={setCrumbIds} setCursor={setCursor} nextUID={nextUID}/> */}
    </div>
  );
}

export default App;
